import { FC } from 'react';
import { BiRightArrowAlt } from 'react-icons/bi';
import { Link } from 'react-router-dom';

interface ITcBack {
  to: string;
}

const TcBack: FC<ITcBack> = ({ to }) => {
  return (
    <Link to={to} className='block px-2 py-1 mb-2 rounded-lg hover:bg-t-layer-bg-color-hovered w-fit bg-t-body-bg'>
      <BiRightArrowAlt className='relative inline top-1' /> بازگشت
    </Link>
  );
};

export default TcBack;
